import { A } from '@solidjs/router'
import { type Component, createMemo } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import Icon from '~/components/Icon'
import type { BreadcrumbsPropsType } from '~/types/Breadcrumbs'

const Breadcrumbs: Component<BreadcrumbsPropsType> = props => {
  const getItemClasses = (active: boolean) =>
    createMemo(() => twMerge('text-sm font-medium', active ? 'text-primary-600 dark:text-primary-500' : 'text-gray-700 hover:text-primary-600 dark:text-gray-400 dark:hover:text-white'))

  const getSpanClasses = (active: boolean) => createMemo(() => twMerge('text-sm font-medium', active ? 'text-primary-600 dark:text-primary-500' : 'text-foreground-subtle'))

  return (
    <nav class="flex mb-3" aria-label="Breadcrumb">
      <ol class="inline-flex items-center space-x-1 md:space-x-2">
        {props.items.map((item, index) => (
          <li class="inline-flex items-center">
            {index > 0 && <Icon icon="material-symbols-light:chevron-right" size={16} class="text-gray-400 mr-2" />}
            {item.href ? (
              <A href={item.href} class={getItemClasses(item.active ?? false)()}>
                {item.title}
              </A>
            ) : (
              <span class={getSpanClasses(item.active ?? false)()}>{item.title}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
